/** Main-branch first-column padding on Dashboard (unchanged with bulk selection). */
export const DASHBOARD_FIRST_COLUMN_PL = 8;

/** Chakra pl={8} as CSS length — used to center bulk checkbox inside dashboard RO column padding. */
export const DASHBOARD_RO_COLUMN_PL_CSS = '2rem';

/** Width of the bulk checkbox hit area in the row gutter. */
export const RO_BULK_CHECKBOX_GUTTER = '18px';

/** Home RO column: shifted right to make room for bulk checkbox (status icon + RO text). */
export const HOME_CONTENT_PL_WITH_BULK = `calc(1.25rem + ${RO_BULK_CHECKBOX_GUTTER})`;

/** Center checkbox in the gutter between row start and status / RO content. */
export const getBulkCheckboxLeft = (contentPlWithBulk: string) =>
    `calc((${contentPlWithBulk} - ${RO_BULK_CHECKBOX_GUTTER}) / 2)`;
